<div class="container"  *ngIf="category!=null">
  <div class="header d-flex align-items-center">
    <div class="logo-icon"></div>
    <h3 class="mr-4">
      <span>更新列表</span>
    </h3>
    <div class="">
      <button class="schedule-date-button" *ngFor="let date of schedule; let last=last;let i = index"
        [ngClass]="{'mr-2': !last, active: key === date.date}" (click)="selectDay(i,date)">
        {{date.label}}
      </button>
    </div>

    <div class="ml-auto">
      <button class="fancy-btn" href="#" *ngFor="let item of categories; let last=last"
        [ngClass]="{'mr-2': !last, active: selectedCategory?.cid === item?.cid && selectedCategory?.region === item?.region }"
        (click)="selectcategory(item)">
        {{item.label}}
      </button>
    </div>
  </div>
  <div class="content">
    <div class="d-flex align-items-start mb-2">

      <div class="v-c" *ngFor="let video of videoList.slice(0, 8); let last=last; let i=index"
       [style.marginRight.px]="responsiveMarginRight(last)"
       [ngClass]="{'visible-lg':i==6 ,'visible-xl':i>=6, 'new': newStyle}"
       (mouseenter)="hoveredCover = i" (mouseleave)="hoveredCover = null"
       >
        <div class="d-block video-item" 
          [video]="video"
          >
        </div>
        <div class="teaserDetail"
          [hovered]="hoveredCover === i ? true : false"
          [video]="video"
          [newStyle]="newStyle">
        </div>
        <div class="teaser-cover" *ngIf="!newStyle">
          <div class="cover-play-area">
            <a [routerLink]="['/play',video.key]" class="cover-play-button" title="{{video.title}}">
              <i class="iconfont iconbofang play-icon"></i>
            </a>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>
